// Scroll-reveal: marks below-the-fold elements as hidden and reveals
// them with a fade + slide-up as they enter the viewport.
//
// Above-the-fold content is left alone (renders instantly). Children
// of staggered containers get an ~80ms cascade so groups feel intentional
// without dragging. Respects prefers-reduced-motion and degrades to
// instant reveal if IntersectionObserver isn't available.

(function () {
  // Bail entirely if user prefers reduced motion — leave page static.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // No IntersectionObserver (old browsers) — bail and let content render normally.
  if (typeof IntersectionObserver === 'undefined') return;

  var STAGGER_MS = 80;

  // Anything whose top is past this fraction of the viewport on initial
  // render is considered "below the fold" and will be animated.
  // 0.65 means: if the element starts more than 65% of the way down the
  // viewport, animate it. Above that threshold = visible enough to render
  // instantly without a fade.
  var BELOW_FOLD_RATIO = 0.65;

  // Individual elements that should reveal one-at-a-time.
  var INDIVIDUAL_SELECTORS = [
    '.custom-merch-section',
    '.custom-image-text-banner',
    '.custom-banner-section',
    '.custom-text-block',
    '.custom-laylo-signup',
    '.custom-hero-header',
    '.custom-mainpaige-header-section',
    'main img',
    'main h1',
    'main h2',
    'main h3',
    'main p',
    'main .button',
    'main .card',
    'main .card-wrapper',
    '.shopify-section .rich-text__blocks',
    '.shopify-section .multicolumn-card',
    '.shopify-section .collage',
    '.shopify-section .image-with-text',
    '.shopify-section .banner__content',
    '.shopify-section .product-grid > *',
    '.shopify-section .featured-collection',
    '.shopify-section .collection-list',
    '.shopify-section .newsletter',
    '.shopify-section .footer-block'
  ];

  // Containers whose direct children should reveal in a staggered cascade
  // when the container enters the viewport.
  var STAGGER_GROUPS = [
    '.custom-hero-buttons',
    '.list-social',
    '.multicolumn-list',
    '.product-grid',
    '.collection-list',
    '.footer__content-bottom-wrapper',
    '.contact__fields'
  ];

  function isBelowFold(el) {
    var rect = el.getBoundingClientRect();
    return rect.top > window.innerHeight * BELOW_FOLD_RATIO;
  }

  function markReveal(el, delayMs) {
    if (el.classList.contains('scroll-reveal')) return false;
    el.classList.add('scroll-reveal');
    if (delayMs) {
      el.style.transitionDelay = delayMs + 'ms';
    }
    return true;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -8% 0px'
  });

  function setup() {
    var elementsToObserve = [];

    // Individual reveals
    INDIVIDUAL_SELECTORS.forEach(function (selector) {
      var nodes;
      try {
        nodes = document.querySelectorAll(selector);
      } catch (e) {
        return;
      }
      nodes.forEach(function (el) {
        if (!isBelowFold(el)) return;
        if (markReveal(el, 0)) elementsToObserve.push(el);
      });
    });

    // Staggered children
    STAGGER_GROUPS.forEach(function (selector) {
      var groups;
      try {
        groups = document.querySelectorAll(selector);
      } catch (e) {
        return;
      }
      groups.forEach(function (group) {
        if (!isBelowFold(group)) return;
        Array.prototype.forEach.call(group.children, function (child, i) {
          if (markReveal(child, i * STAGGER_MS)) elementsToObserve.push(child);
        });
      });
    });

    // Start observing
    elementsToObserve.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
